import React, { useState } from 'react';
import styles from './asset/userInvitationHolder.module.scss';

const UserInvitationHolder = () => {
    const [email, setEmail] = useState('YourFriend@gmail.com');
    const [referralLink] = useState('Http://Prepal.com/referral');

    const handleCopyLink = () => {
        navigator.clipboard.writeText(referralLink);
        // Add toast notification here if needed
    };

    const handleSendInvite = () => {
        // Handle email invitation logic
        console.log('Sending invite to:', email);
    };

    return (
        <div className={styles.frameParent}>
            <div className={styles.converted2Wrapper}>
                <img
                    className={styles.converted2Icon}
                    alt="Invitation illustration"
                    src={require('../../publicAsset/media/InvitationIlustration.svg').default}
                />
            </div>

            <div className={styles.frameGroup}>
                <section className={styles.frameContainer}>
                    {/* Share Link Section */}
                    <div className={styles.frameContainer}>
                        <h3 className={styles.shareInviteLink}>Share invite link</h3>
                        <div className={styles.inputParent}>
                            <input
                                type="url"
                                className={styles.input}
                                value={referralLink}
                                readOnly
                                aria-label="Referral link"
                            />
                            <button
                                type="button"
                                className={styles.buttons}
                                onClick={handleCopyLink}
                                aria-label="Copy referral link"
                            >
                                <span className={styles.button}>Copy</span>
                            </button>
                        </div>
                    </div>

                    {/* Email Invite Section */}
                    <div className={styles.frameContainer}>
                        <h3 className={styles.shareInviteLink}>Send Email Invite</h3>
                        <form className={styles.inputParent} onSubmit={(e) => { e.preventDefault(); handleSendInvite(); }}>
                            <input
                                type="email"
                                className={styles.input}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter friend's email"
                                aria-label="Friend's email address"
                                style={{ color: '#D9D9D9' }}
                                required
                            />
                            <button
                                type="submit"
                                className={styles.buttons}
                                aria-label="Send invitation"
                            >
                                <span className={styles.button}>Invite</span>
                            </button>
                        </form>
                    </div>
                </section>

                {/* Rewards Section */}
                <section className={styles.rewardParent}>
                    <article className={styles.reward}>
                        <div className={styles.frameDiv}>
                            <img
                                className={styles.frameChild}
                                alt="Rewards icon"
                                src="Frame 46414.svg"
                            />
                            <div className={styles.rewardsEarned}>
                                <p className={styles.rewards}>Rewards</p>
                                <p className={styles.rewards}>Earned</p>
                            </div>
                        </div>
                        <hr className={styles.rewardChild} />
                        <div className={styles.div}>$0.00</div>
                    </article>

                    <article className={styles.reward}>
                        <div className={styles.frameDiv}>
                            <img
                                className={styles.frameChild}
                                alt="Credit icon"
                                src="Frame 46414.svg"
                            />
                            <div className={styles.rewardsEarned}>
                                <p className={styles.rewards}>Credit</p>
                                <p className={styles.rewards}>Balance</p>
                            </div>
                        </div>
                        <hr className={styles.rewardChild} />
                        <div className={styles.div}>$0.00</div>
                    </article>

                    <article className={styles.reward}>
                        <div className={styles.frameDiv}>
                            <img
                                className={styles.frameChild}
                                alt="Invites icon"
                                src="Frame 46414.svg"
                            />
                            <div className={styles.rewardsEarned}>
                                <p className={styles.rewards}>Successful</p>
                                <p className={styles.rewards}>Invites</p>
                            </div>
                        </div>
                        <hr className={styles.rewardChild} />
                        <div className={styles.div}>0</div>
                    </article>
                </section>
            </div>
        </div>
    );
};

export default UserInvitationHolder;